import { getGaUserType } from '@/hooks';
import ReactGA4 from 'react-ga4';

export const loginGa = ({
  hasConnected,
  action,
  userType,
}: {
  hasConnected?: boolean;
  action: string;
  userType?: string;
}) => {
  const prefix = hasConnected ? 'Connected' : 'NotConnect';
  ReactGA4.event({
    category: `${prefix} Login Conversion`,
    action: `${prefix}_${action}_${userType || getGaUserType()}`,
  });
};
